import React from 'react';
import { useOutletContext } from 'react-router-dom';

import { ROUTE } from '~/app/routes';
import { PaginationWrapper, SectionHeader } from '~/components';
import { useNavigate } from '~/lib/navigation';

import { disbursementColumns, disbursementFilter, handleFetchDisbursements } from './Disbursement/Overview';
import { LoanProps } from './Loan';

export const PageLoanDisbursements: React.FC = () => {
  const navigate = useNavigate();
  const { loan } = useOutletContext<LoanProps>();

  if (!loan?.id) {
    return null;
  }

  return (
    <>
      <SectionHeader text="Disbursements" />

      <PaginationWrapper
        tableId="loanDisbursements"
        fetch={(o) => handleFetchDisbursements({ ...o, loanId: loan.id }, navigate)}
        columns={disbursementColumns}
        filter={disbursementFilter}
        rowClick={(row) => {
          navigate(`${ROUTE.LOANS}/disbursements/edit/${row.original.id}`);
        }}
      />
    </>
  );
};
